<template>
  <breadcrumb :title="title" :subTitle="subTitle" :link="link" />
  <div class="container">
    <div class="row">
        <Sidebar />
        <profile />
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/layouts/breadcrumb.vue";
import Sidebar from '@/components/layouts/sidebar.vue';
import profile from '@/components/include/profile/profile.vue';
export default {
  data() {
    return {
      title: this.$t("profile"),
      subTitle: "",
      link: "",
    };
  },
  components: { breadcrumb, Sidebar, profile },
};
</script>

<style>
</style>